// extracted by mini-css-extract-plugin
module.exports = {"container":"MiniAppHeader_container__2L33_","text":"MiniAppHeader_text__uoRv9","homeIcon":"MiniAppHeader_homeIcon__3KGGz","actions":"MiniAppHeader_actions__2uHWx"};